import useSWR from "swr";

type SurveyQuestions = {
  id: string;
  restaurant: string;
  question: string;
  answer_count: number;
  is_selected: boolean;
}[]

export const useFetchKuchikomyuSurveyQuestionsByRestaurantId = (restaurantId?: string) => {
  const fetcherKey = restaurantId ? `kuchikomyu/restaurants/${restaurantId}/survey/questions/` : null;
  const { data: surveyQuestions, error, isLoading } = useSWR<SurveyQuestions>(fetcherKey)
  return { surveyQuestions, isLoading, error };
};
